module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('a', {
    attrs: {
      "id": "front2"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chaptertitle1"
  }, [_vm._v("DRAMATIS PERSONAE")]), _vm._v(" "), _c('p', {
    staticClass: "series01",
    attrs: {
      "id": "front2_p1"
    }
  }, [_vm._v("Note that in Chinese the surname—here printed in capitals—precedes the personal name")]), _vm._v(" "), _c('p', {
    staticClass: "body-text01",
    attrs: {
      "id": "front2_p2"
    }
  }, [_c('i', [_vm._v("The Morning of the Monkey:")])]), _vm._v(" "), _c('p', {
    staticClass: "img",
    attrs: {
      "id": "front2_p3"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "210",
      "src": "images/v-1.jpg",
      "width": "453"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "body-text01",
    attrs: {
      "id": "front2_p4"
    }
  }, [_c('i', [_vm._v("The Night of the Tiger:")])]), _vm._v(" "), _c('p', {
    staticClass: "img",
    attrs: {
      "id": "front2_p5"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "228",
      "src": "images/v-2.jpg",
      "width": "455"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "front2_p6"
    }
  }, [_vm._v("In the accompanying Chinese zodiac—always represented with the south at the top—the images of the Monkey and the Tiger indicate their correct position; the other animals are represented by their cyclical signs only. The complete set, known as the Twelve Branches of Heaven*, consists of 1 Rat (Aries), 2 Cow (Taurus), 3 Tiger (Gemini), 4 Hare (Cancer), 5 Dragon (Leo), 6 Serpent (Virgo), 7 Horse (Libra), 8 Sheep (Scorpio), 9 Monkey (Sagittarius), 10 Cock (Capricorn), 11 Dog (Aquarius) and 12 Pig (Pisces). This series also indicates the 24 hours of a natural day: the Rat 11-1 a.m., the Cow 1-3 a.m., etc")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "front2_p7"
    }
  }, [_vm._v("A second cyclical series (not depicted here) consists of the ‘Ten Stems of Earth’, which represents also the Five Elements and the Five Planets, viz. I "), _c('i', [_vm._v("chia")]), _vm._v(", II "), _c('i', [_vm._v("yi")]), _vm._v(" (both wood and Jupiter), III ping, IV "), _c('i', [_vm._v("ting (fire")]), _vm._v(" and Mars), V "), _c('i', [_vm._v("mou")]), _vm._v(", VI "), _c('i', [_vm._v("chi (earth")]), _vm._v(" and Saturn), VII keng, VIII "), _c('i', [_vm._v("hsin (metal")]), _vm._v(" and Venus), IX Jen, X "), _c('i', [_vm._v("kuei (water")]), _vm._v(" and Mercury). The twelve ‘branches’, combined with the ten ‘stems’, form a sexagenary cycle: I-1, II-2, III-3, IV-4, V-5, VI-6, VII-7, VIII-8, IX-9, X-10, I-11, II-12, III-1, IV-2 and so on till X-12. This cycle of sixty double signs is the basis of Chinese chronology. Six cycles indicate the 360 days of a tropical year and ‘the twelve lunar months, and also the years themselves in an ever-repeating series of sixty—‘A cycle of Cathay’! The year 1900 was VII-1, a year of the Rat, and we are living now in the cycle that began in 1924 with the year of the Rat I-1; this particular cycle ends in 1984. The current year, 1965, is II-6, a year of the Serpent, 1966 will be III-7, a year of the Horse.")]), _vm._v(" "), _c('p', {
    staticClass: "indent",
    attrs: {
      "id": "front2_p8"
    }
  }, [_vm._v("The octagonal design in the centre of the zodiac is explained in the Postscript")]), _vm._v(" "), _c('p', {
    staticClass: "img",
    attrs: {
      "id": "front2_p9"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "height": "417",
      "src": "images/vii-1.jpg",
      "width": "476"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4bce3ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/front2.vue
// module id = 66
// module chunks = 0